/**
 * ShiftSwap's footer disclaimer (brief §E5).
 *
 * The vendored `Disclaimer` in `src/ui` is a prop-less component with its
 * text hard-coded to the pay calculator ("Estimate only... check your
 * payslip") — wrong for this app, and not something to edit in place, since
 * an in-place patch to a vendored file is lost at the next sync and silently
 * reverts. This local component carries ShiftSwap's own wording instead,
 * reusing the vendored `sl-disclaimer` class so it still inherits Station
 * Ledger's styling.
 *
 * If a third consumer of a disclaimer ever shows up, the right fix is
 * upstream — `Disclaimer({ children })` in OTcalculator, re-vendored here —
 * not a second local component like this one.
 */
export function AppDisclaimer() {
  return (
    <p className="sl-disclaimer">
      An unofficial, staff-built tool. Not connected to the official roster —
      submit every confirmed swap to workforce planning.
    </p>
  )
}
